import React from 'react';
import { Disclosure } from '@headlessui/react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Logo from '../icons/Logo';
import useSelectedCommunity from '../../../hooks/community/useSelectedCommunity';
import useAuth from '../../../hooks/account/useAuth';
import Language from '../../../types/language';
import useLanguage from '../../../hooks/account/useLanguage';
import { setLanguage } from '../../../redux/slices/applicationSlice';

export default function NavBar(): JSX.Element {
  const navigate = useNavigate();
  const auth = useAuth();
  const community = useSelectedCommunity();
  const dispatch = useDispatch();
  const lang = useLanguage();

  return (
    <>
      <div className="sticky top-0 z-50 w-full">
        <Disclosure as="nav" className="flex items-center">
          {(): JSX.Element => (
            <>
              <div className="z-50 w-full rounded-b-2xl bg-secondary-200 px-5">
                <div className="z-50 mx-auto w-full max-w-7xl bg-secondary-200">
                  <div className="flex h-16 items-center justify-between">
                    <div
                      onClick={() => navigate(auth && community ? '/overview' : '/')}
                      className="flex max-w-7xl flex-1 items-center justify-start sm:items-stretch">
                      <Logo />
                    </div>
                    <div className="flex items-center gap-4 sm:static sm:inset-auto">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/flags/${
                          lang === Language.NL ? Language.EN : Language.NL
                        }.svg`}
                        alt="Nederlands"
                        onClick={() =>
                          dispatch(setLanguage(lang === Language.NL ? Language.EN : Language.NL))
                        }
                        className="h-6 w-6 cursor-pointer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Disclosure>
        <Outlet />
      </div>
    </>
  );
}
